import React from 'react';
export function RevelacionSection() {
  return <section className="bg-white py-16 md:py-24 px-4" data-id="element-136">
      <div className="max-w-4xl mx-auto" data-id="element-137">
        <div className="max-w-3xl mx-auto text-center space-y-6 text-xl md:text-2xl text-gray-800 leading-relaxed" data-id="element-138">
          <p data-id="element-139">
            Cuando las personas hacen este ejercicio por primera vez descubren
            algo sorprendente:
          </p>
          <br data-id="element-140" />
          <p className="font-bold text-gray-900" data-id="element-141">
            Gran parte de tu día está ocupado en actividades que no generan
            crecimiento.
          </p>
          <br data-id="element-142" />
          <p data-id="element-143">Y mientras eso no cambie…</p>
          <br data-id="element-144" />
          <p className="text-[#D90B10] font-bold text-2xl md:text-3xl" data-id="element-145">
            el negocio se estanca.
          </p>
        </div>
      </div>
    </section>;
}